import dayjs from "dayjs";

import { INITIAL_SALE_EVENT_CONTEXT, UTIL_CART, IS_SELECTED_SERVICES, IS_SEATS_REQUEST } from "../../../constants";
import { SelectPaymentMethodDTO, AddPaymentInfoEvent, ISelectedService, Item } from "./selectPaymentMethod.dto";
import { RegistryDto } from "../../services/registry.dto";
import {
  _calculateTotalAmountAndQuantity,
  _createVariantSeatsString,
  _createVariantString,
  _mergeCoutingObjects,
} from "../misc-utils";
import { validateSessionByCookie } from "../../services/cookies";

export const handleSelectPaymentMethodEvent = (data: SelectPaymentMethodDTO) => {
    const {
      env: environment,
      isApp: app,
      isCorpo: corp,
    } = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");

    const isApp = data.negocio === 'APP';
    const isCorpo = data.negocio === 'CORPORATE' || data.negocio === 'STATEPORTAL';

    const selectedServices: ISelectedService[]  =
    JSON.parse(window.localStorage.getItem(IS_SELECTED_SERVICES) ?? "[]") as ISelectedService[];

    const bagsServicesTypes = ["luggage", "specialLuggage"];
    const bagsServices = selectedServices
                            ?.filter(service => bagsServicesTypes.includes(service.ancillaryType))
                            ?.map(service => service.passengers)
                            .reduce((acc, val) => acc.concat(val), [])
                            .reduce((acc, curr) => acc + curr.quantity, 0);

    const carryOnServicesTypes = ["carry"];
    const carryOnServices = selectedServices
    ?.filter(service => carryOnServicesTypes.includes(service.ancillaryType))
    ?.map(service => service.passengers)
    .reduce((acc, val) => acc.concat(val), [])
    .reduce((acc, curr) => acc + curr.quantity, 0);

    const petServicesTypes = ["cabinPet", "luggagePet"];
    const petsServices = selectedServices
                          ?.filter(service => petServicesTypes.includes(service.ancillaryType))
                          ?.map(service => service.passengers)
                          .reduce((acc, val) => acc.concat(val), [])
                          .reduce((acc, curr) => acc + curr.quantity, 0);

    const { queryParams } = JSON.parse(
      window.localStorage.getItem("Origin") ?? "false"
    );
    
    const utilCart = JSON.parse(window.localStorage.getItem(UTIL_CART) ?? "{}"); 

    const fullTrip = [];
    const fullTripDates = [];
    const fullTripTimes = [];
    
    const iSSeatsRequest = JSON.parse(
      window.localStorage.getItem(IS_SEATS_REQUEST) ?? "[]"
    ) as any;
    
    const selectedSeatsTypes = ["ADT", "CHD"];
    const selectedSeats = iSSeatsRequest?.passengers?.reduce(
      (acc, passenger) => selectedSeatsTypes.includes(passenger.type) ? acc + 1 : acc, 0
    );

    iSSeatsRequest?.itineraryParts?.map((flight) => {
      flight.segments.map((segment) => {
        fullTripDates.push(dayjs(segment.departure).format("YYYY-MM-DD"));
        fullTrip.push(`${segment.origin}-${segment.destination}`);
        fullTripTimes.push(
          `${dayjs(segment.arrival).format("hh:mm")}(${segment.origin})|${dayjs(
            segment.departure
          ).format("hh:mm")}(${segment.destination})`
        );
      });
    });

    const bundleInfoGoingReturn = iSSeatsRequest?.itineraryParts?.map((flight) => {
      return flight.segments[0].fareBasis;
    });

    const count_passengers_adult = queryParams?.ADT ? parseInt(queryParams?.ADT) : 0;
    const count_passengers_child = queryParams?.CHD ? parseInt(queryParams?.CHD) : 0;
    const count_passengers_infant = queryParams?.INF ? parseInt(queryParams?.INF) : 0;

    const addPaymentParams = {
      payment_method: data.payment_method,
      payment_type: data.payment_type,
      exchange_rate: data.exchange_rate,
      buy_instance: data.stage,
      environment: environment || data.environment,
      corp: corp || isCorpo,
      app: app || isApp,
      page_path: data.page_path,
      micrositio: data.micrositio,
      page_type: data.page_type,
      negocio: data.negocio,
      login: validateSessionByCookie(),
      homemarket: data.homemarket,
      currency: data.currency,
      count_seats: selectedSeats,
      count_bags: bagsServices,
      count_carry_on: carryOnServices + count_passengers_adult + count_passengers_child,
      initial_date: queryParams?.departureDate,
      end_date: queryParams?.arrivalDate,
      from_iata: queryParams?.origin,
      to_iata: queryParams?.destination,
      trip_type: queryParams?.flightType === "RT" ? "roundtrip" : "oneway",
      time: fullTripTimes.join(","),
      full_trip: fullTrip.join(),
      full_trip_dates: fullTripDates.join(),
      full_trip_fare_basis: !queryParams?.flightType ? "" : queryParams?.flightType === "RT"
      ? `${bundleInfoGoingReturn[0]}|${bundleInfoGoingReturn[1]}`
      : `${bundleInfoGoingReturn[0]}`,
      fare_basis: !queryParams?.flightType ? "" : queryParams?.flightType === "RT"
      ? `${bundleInfoGoingReturn[0]}|${bundleInfoGoingReturn[1]}`
      : `${bundleInfoGoingReturn[0]}`,
      bundle: !queryParams?.flightType ? "" : queryParams?.flightType === "RT"
      ? `${bundleInfoGoingReturn[0].substring(
          1
        )}|${bundleInfoGoingReturn[1].substring(1)}`
      : `${bundleInfoGoingReturn[0].substring(1)}`,
      passengers_child: count_passengers_child,
      passengers_adult: count_passengers_adult,
      passengers_infant: count_passengers_infant,
      passengers_pet: petsServices,
      pax:
        parseInt(queryParams?.ADT ?? "0") +
        parseInt(queryParams?.CHD || "0") +
        parseInt(queryParams?.INF || "0"),
    }

    const ecommerce = {
      transaction_id: data.transactionId,
      affiliation: 'Sky | Chile',
      currency: data.currency,
      value: data.value || utilCart?.subTotal,
      tax: utilCart?.subTaxes,
    }

  return {
    event: "select_payment_method",
    event_params: addPaymentParams,
    // ecommerce,
  };
}
